var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0 svg-elem-1",
    points: "57.7,48.7 37,3.1 19.1,42.6 8.5,42.6 8.5,48.5 16.5,48.5 22.7,48.5 22.7,48.5 22.7,48.5 27.7,37.3  29.9,32.3 36.9,16.7 37.6,18.2 57.5,63.3 77.7,18.2 71.4,18.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 18.1,
    className: "st0 svg-elem-2",
    width: 5.9,
    height: 43.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0 svg-elem-3",
    points: "123.8,18.2 123.8,18.2 109.9,49.2 96.2,18.2 89.9,18.2 109.8,63.4 127.5,24.1 137.6,24.1 137.6,18.2  130.1,18.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1 svg-elem-4",
    points: "270.7,18.2 258.1,46.9 245.6,18.2 239.6,18.2 255.1,53.7 255.1,53.7 255.1,53.7 247.8,70.6  253.8,70.6 258.1,60.6 258.1,60.6 261.1,53.7 276.6,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-5",
    d: "M230.9,24.6c-3.6-3.9-8.8-6.4-14.5-6.4c-11,0-19.9,8.9-19.9,19.9c0,11,8.9,19.9,19.9,19.9 c5.7,0,10.9-2.5,14.5-6.4v6.1h5.5V18.2h-5.5V24.6z M216.4,52.6c-8,0-14.5-6.5-14.5-14.5c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5 C230.8,46.1,224.3,52.6,216.4,52.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.9,
    y: 10.1,
    className: "st1 svg-elem-6",
    width: 5.5,
    height: 47.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-7",
    d: "M161,18.2c-5.7,0-10.9,2.5-14.5,6.4v-6.4H141v52.4h5.5V51.6c3.6,3.9,8.8,6.4,14.5,6.4c11,0,19.9-8.9,19.9-19.9 C180.9,27.1,172,18.2,161,18.2z M161,52.6c-8,0-14.5-6.5-14.5-14.5c0-8,6.5-14.5,14.5-14.5s14.5,6.5,14.5,14.5 C175.5,46.1,169,52.6,161,52.6z"
  }))));
}
export default __webpack_public_path__ + "static/media/loading.062c5e28.svg";
export { SvgLoading as ReactComponent };